var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',_vm._g(_vm._b({staticClass:"clickable ml-1",attrs:{"title":_vm.$t('delete')}},'icon',_vm.$attrs,false),_vm.$listeners),[_vm._v("delete")])}
var staticRenderFns = []

export { render, staticRenderFns }